var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKpiPanel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 2.25C1.34315 2.25 0 3.59315 0 5.25V18.75C0 20.4069 1.34315 21.75 3 21.75H21C22.6569 21.75 24 20.4069 24 18.75V5.25C24 3.59315 22.6569 2.25 21 2.25H3ZM3 3.75C2.17157 3.75 1.5 4.42157 1.5 5.25V18.75C1.5 19.5784 2.17157 20.25 3 20.25H21C21.8284 20.25 22.5 19.5784 22.5 18.75V5.25C22.5 4.42157 21.8284 3.75 21 3.75H3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 11.1C3 10.9343 3.13431 10.8 3.3 10.8H20.7C20.8657 10.8 21 10.9343 21 11.1V12C21 12.1657 20.8657 12.3 20.7 12.3H3.3C3.13431 12.3 3 12.1657 3 12V11.1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 14.0999C3 13.9342 3.13431 13.7999 3.3 13.7999H20.7C20.8657 13.7999 21 13.9342 21 14.0999V14.9999C21 15.1656 20.8657 15.2999 20.7 15.2999H3.3C3.13431 15.2999 3 15.1656 3 14.9999V14.0999Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 17.0999C3 16.9342 3.13431 16.7999 3.3 16.7999H20.7C20.8657 16.7999 21 16.9342 21 17.0999V17.9999C21 18.1656 20.8657 18.2999 20.7 18.2999H3.3C3.13431 18.2999 3 18.1656 3 17.9999V17.0999Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.3 5.25C3.13431 5.25 3 5.38431 3 5.55V9.45C3 9.61569 3.13431 9.75 3.3 9.75H20.7C20.8657 9.75 21 9.61569 21 9.45V5.55C21 5.38431 20.8657 5.25 20.7 5.25H3.3ZM19.5 6.75H18V8.25H19.5V6.75ZM14.625 6.75H16.125V8.25H14.625V6.75ZM12.75 6.75H11.25V8.25H12.75V6.75ZM7.875 6.75H9.375V8.25H7.875V6.75ZM6 6.75H4.5V8.25H6V6.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKpiPanel);
export default __webpack_public_path__ + "static/media/kpi-panel.ce62c870ced554936c7fc10a6a707ac8.svg";
export { ForwardRef as ReactComponent };